module.exports = __webpack_public_path__ + "static/wedding-62025b8d228ff478c8866db6844677ae.jpg";